import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import useQuery from 'hooks/useQuery';

const occupancyQuery = `
  query GetMetricsOccupancyRateLive($input: MetricsLiveOccupancyRateInput!) {
    metricsLiveOccupancyRate(input: $input) {
      rate
    }
  }
`;

const useCarparkFullWarning = () => {
  const token = useSelector((state) => _get(state, 'auth.token', null));
  const carparkId = useSelector((state) => _get(state, 'cpmCarpark.current.data.id', null));

  const { data: occupancyData } = useQuery({
    query: occupancyQuery,
    variables: {
      input: {
        carparkId,
        parkingType: 'ON_DEMAND',
      },
    },
    token,
  });

  const carparkIsFull = _get(occupancyData, 'metricsLiveOccupancyRate.rate', 0) >= 1;
  const [showCarparkFullModal, setShowCarparkFullModal] = useState(false);
  const [pendingValidation, setPendingValidation] = useState(null);

  const checkCarparkFullAndValidate = useCallback((validationData, onValidate) => {
    if (carparkIsFull) {
      // Store the validation data to use later if the user confirms
      setPendingValidation({ validationData, onValidate });
      setShowCarparkFullModal(true);
      return false; // Validation blocked
    }
    // Carpark is not full, proceed with validation
    onValidate(validationData);
    return true; // Validation proceeded
  }, [carparkIsFull]);

  const handleContinue = useCallback(() => {
    if (pendingValidation) {
      pendingValidation.onValidate(pendingValidation.validationData);
      setPendingValidation(null);
    }
    setShowCarparkFullModal(false);
  }, [pendingValidation]);

  const handleCancel = useCallback(() => {
    setPendingValidation(null);
    setShowCarparkFullModal(false);
  }, []);

  return {
    showCarparkFullModal,
    checkCarparkFullAndValidate,
    handleContinue,
    handleCancel,
  };
};

export default useCarparkFullWarning;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/onDemand/hooks/useCarparkFullWarning.js